<template>
  <div id="map"></div>
</template>
<script>
export default {
  name: "Map",
  data() {
    return {
      // 经度
      longitude: 113.573044,
      // 纬度
      latitude: 34.821643,
      description:
        "No.2 Fengyang Street, High-Tech Zone, Zhengzhou, P. R. China Postcode: 450001"
    };
  },
  methods: {
    createMap() {
      // 创建Map实例
      var map = new BMap.Map("map");
      // 初始化地图,设置中心点坐标和地图级别
      var point = new BMap.Point(this.longitude, this.latitude);
      // var marker = new BMap.Marker(point);
      // map.addOverlay(marker);
      map.centerAndZoom(point, 10);
      //添加地图类型控件
      map.addControl(
        new BMap.MapTypeControl({
          mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP]
        })
      );
      // 设置地图显示的城市 此项是必须设置的
      map.setCurrentCity("郑州");
      //开启鼠标滚轮缩放
      map.enableScrollWheelZoom(true);
      // 信息窗的配置信息
      var opts = {
        width: 350,
        height: 75,
        title: "Address: "
      };
      // 创建信息窗口对象
      var infoWindow = new BMap.InfoWindow(this.description, opts);
      // marker.addEventListener("click", function () {
      //   map.openInfoWindow(infoWindow, point);
      // });
      map.enableScrollWheelZoom(true);
      //开启信息窗口
      // map.openInfoWindow(infoWindow, point);
    }
  },
  mounted() {
    this.createMap();
  }
};
</script>
<style scoped>
</style>
